import { getMissingModelCodes } from "utils/codes";
import { collectEcmSubTypesForPackageUpgrade } from "utils/packageUpgradeEcmCategories";

const getAllEcmInputMapUpgrades = (ecmInputMap = {}) => {
    const allEcmInputMapUpgradesArr = ecmInputMap
        ? Object.keys(ecmInputMap)
              .map((key) =>
                  Object.entries(ecmInputMap[key])
                      .filter(([k, _]) => k !== "None")
                      .map(([k, v]) => ({ [k]: v }))
              )
              .flat()
        : [];

    return allEcmInputMapUpgradesArr.reduce((acc, curr) => ({ ...acc, ...curr }), {});
};

const getCodesFromEcmUpgrades = (allEcmInputMapUpgrades = {}) => {
    return Object.values(allEcmInputMapUpgrades).reduce(
        (acc, curr) => ({ ...acc, ...(curr.packageValues?.codes || {}) }),
        {}
    );
};

/**
 * Table upgrades (commUpgrades.packages) that are missing or mismatched in community ecmInputMap.
 * Aligns with saveEcmInputMap prune expectations: row key + packageValues.upgradePackageId.
 */
export const getTableUpgradesMissingFromEcmInputMap = (packages = {}, ecmInputMap = {}) => {
    const issues = [];

    Object.entries(packages).forEach(([packageId, pkg]) => {
        if (packageId === "base") return;

        const packageName = pkg?.name || packageId;
        const upgrades = pkg?.upgrades || {};

        Object.entries(upgrades).forEach(([upgradeId, upgrade]) => {
            if (!upgrade || upgrade.upgradeType === "baseLoads") return;

            let categories = collectEcmSubTypesForPackageUpgrade(upgrade);
            if (categories.length === 0) {
                const fallback =
                    upgrade.upgradeSubType ||
                    (upgrade.label && typeof upgrade.label === "object" ? Object.keys(upgrade.label)[0] : null);
                categories = fallback ? [fallback] : [];
            }

            const labelText =
                (upgrade.label && Object.values(upgrade.label).find((v) => v != null && v !== "")) ||
                "Label not found";

            if (categories.length === 0) {
                issues.push({
                    packageId,
                    packageName,
                    upgradeId,
                    category: upgrade.upgradeType || "",
                    labelText,
                    reason: "missing_category",
                });
                return;
            }

            categories.forEach((category) => {
                const row = ecmInputMap[category]?.[upgradeId];
                if (!row) {
                    issues.push({
                        packageId,
                        packageName,
                        upgradeId,
                        category,
                        labelText,
                        reason: "missing_ecm_row",
                    });
                    return;
                }

                const pkgOnRow = row?.packageValues?.upgradePackageId;
                if (pkgOnRow !== packageId) {
                    issues.push({
                        packageId,
                        packageName,
                        upgradeId,
                        category,
                        labelText,
                        reason: "package_id_mismatch",
                        ecmPackageId: pkgOnRow || "",
                    });
                }
            });
        });
    });

    return issues;
};

export const getMissingEcmInputMapCodes = (upgradePackages = {}, ecmInputMap = {}) => {
    const allEcmInputMapUpgrades = getAllEcmInputMapUpgrades(ecmInputMap);

    const modelCodes = getCodesFromEcmUpgrades(allEcmInputMapUpgrades);

    return getMissingModelCodes(upgradePackages, modelCodes);
};
